import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
export interface ConfirmDialogueAction {
  actionIcon?: string;
  actionName: string;
  actionClass?: string;
}
@Component({
  selector: 'app-confirmation-dialogue',
  templateUrl: './confirmation-dialogue.component.html',
  styleUrls: ['./confirmation-dialogue.component.scss']
})
export class ConfirmationDialogueComponent {
  activeModal = inject(NgbActiveModal);
  @Input() ConfirmationTitle!: string;
  @Input() ConfirmationMessage!: string;
  @Input() Action!: ConfirmDialogueAction;
  constructor() {}
}
